import { createSelector } from "reselect";

const assetSelector = (state) => state.asset;
const dealSelector = (state) => state.deal;
const spacesSelector = (state) => state.spaces;

const spacesArraySelector = createSelector(spacesSelector, (spaces) =>
  Object.keys(spaces).map((id) => spaces[id])
);

export const getSpacesByAsset = createSelector(
  spacesArraySelector,
  assetSelector,
  (spaces, asset) => spaces.filter((space) => space.assetId === asset.id)
);

export const getSpacesByDeal = createSelector(spacesArraySelector, dealSelector, (spaces, deal) =>
  spaces.filter((space) => deal.assets.some((asset) => asset.id === space.assetId))
);

export const getSelectedSpacesByDeal = createSelector(
  getSpacesByDeal,
  dealSelector,
  (spaces, deal) =>
    // TODO: fix my response
    spaces.filter((space) => (deal.spaces || []).some((dealSpace) => dealSpace.id === space.id))
);

export const isEditing = createSelector(getSpacesByAsset, (spaces) =>
  spaces.some((space) => space.isEdit)
);

export const getSpaces = createSelector(spacesArraySelector, (spaces) => spaces);
